import { render } from "./custom-search-web.vue?vue&type=template&id=233714f2"
import script from "./custom-search-web.vue?vue&type=script&lang=js"
export * from "./custom-search-web.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MY PROJECTS\\VUE_3\\EXCEL_LIBRARY\\excel-library-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__